export default __webpack_public_path__ + "static/media/contactBG.3c83435a.jpg";